export default [
  {
    key: 'search',
    label: 'general.search',
    rules: 'required',
    type: 'text',
    repository: 'department',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: true,
    lg: 4,
  },
  {
    key: 'serviceType',
    label: 'breadcrumb.serviceType',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'department',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: true,
    lg: 4,
  },
  {
    key: 'project',
    label: 'breadcrumb.project',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'department',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: true,
    lg: 4,
  },
  {
    key: 'department',
    label: 'field.department',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'department',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: true,
    lg: 4,
  },
  {
    key: 'operator',
    label: 'field.origin',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'chatOperator',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: true,
    lg: 4,
  },
  {
    key: 'operator',
    label: 'field.operator',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'chatOperator',
    selectionKey: 'id',
    selectionLabel: 'name',
    clearable: true,
    lg: 4,
  },
  // {
  //   key: 'priority',
  //   label: 'ticket.priority',
  //   type: 'radio',
  //   options: [
  //     { text: 'chat.all', value: '' },
  //     { value: '1', text: 'chat.highPriority' },
  //   ],
  //   lg: 4,
  //   skip: true,
  // },
  // {
  //   key: 'status',
  //   label: 'field.status',
  //   type: 'radio',
  //   options: [
  //     { text: 'chat.all', value: '' },
  //     { value: 'pending', text: 'status.pending' },
  //     { value: 'accepted', text: 'status.accepted' },
  //     { value: 'processing', text: 'status.processing' },
  //     { value: 'pendingPrice', text: 'status.pendingPrice' },
  //     { value: 'hold', text: 'status.hold' },
  //     { value: 'cancel', text: 'status.cancel' },
  //     { value: 'completed', text: 'status.completed' },
  //     { value: 'resolved', text: 'status.closed' },
  //   ],
  //   md: 12,
  //   lg: 12,
  //   skip: true,
  // },
  {
    key: 'period',
    label: 'field.date',
    type: 'radio',
    options: [
      { text: 'field.today', value: 'today' },
      { text: 'field.yesterday', value: 'yesterday' },
      { text: 'field.thisWeek', value: 'thisWeek' },
      { text: 'field.lastWeek', value: 'lastWeek' },
      { text: 'field.thisMonth', value: 'thisMonth' },
      { text: 'field.lastMonth', value: 'lastMonth' },
      { text: 'field.other', value: 'other' },
    ],
    md: 12,
    lg: 8,
    skip: true,
  },
  {
    lg: 4,
  },
  {
    key: 'startDate',
    label: 'field.fromDate',
    type: 'date',
    lg: 4,
  },
  {
    key: 'endDate',
    label: 'field.toDate',
    type: 'date',
    lg: 4,
  },
]
